<template>
    <span class="quick-guide-button">
      {{ value }}
      <a
        v-if="fileLink"
        class="quick-guide-link"
        :href="fileLink"
        target="_blank"
      >
        <font-awesome-icon class="rocket-launch-icon" :icon="['fal', 'rocket-launch']" />
        <span>{{ $t('QuickGuide') }}</span>
      </a>
    </span>
</template>

<script>
export default {
  name: 'CellRendererQuickGuideButton',
  computed: {
    value() {
      return this.params.value;
    },
    fileLink() {
      const childRows = this.params.node.allLeafChildren;
      let quickGuideUrl = null;

      childRows.forEach(function ({ data }) {

        if (data.QuickGuideUrl) {
          quickGuideUrl = data.QuickGuideUrl;
        }
      })

      return quickGuideUrl;
    },
  },
}
</script>

<style lang="scss">
.quick-guide-button {
    display: flex;
    align-items: center;
    justify-content: space-between;

  .quick-guide-link {
    cursor: pointer;
    // position: relative;
    display: inline-block;
    line-height: 20px;
    // height: 33px;
    font-size: 14px;
    background-color: #fff;
    border-radius: 30px;
    padding: 6.5px 15px;

    .rocket-launch-icon {
      padding-right: 5px;
    }
  }
}
</style>
